import {
  BookOpen,
  MapPin,
  GraduationCap,
  Pill,
  TestTubes,
  Gift,
  Syringe,
  Stethoscope,
  FileText,
  ClipboardList,
  HeartPulse,
  Activity,
} from "lucide-react-native";
import type { LucideIcon } from "lucide-react-native";

export type SearchCategory =
  | "articles"
  | "clinics"
  | "programs"
  | "supplements"
  | "tests"
  | "grants"
  | "medications"
  | "providers"
  | "documents"
  | "conditions"
  | "procedures"
  | "therapies";

export type SearchItemImage =
  | { type: "uri"; uri: string }
  | { type: "require"; source: number }
  | { type: "initials"; initials: string; bgColor: string };

export type SearchItem = {
  id: string;
  category: SearchCategory;
  title: string;
  subtitle?: string;
  keywords?: string;
  /** Optional image to display instead of the category icon */
  image?: SearchItemImage;
  navTarget?: {
    tab: string;
    screen: string;
    params?: Record<string, unknown>;
  };
};

export type CategoryConfig = {
  label: string;
  icon: LucideIcon;
  color: string;
  /** Lower = more important. Used as tiebreaker when match scores are equal. */
  priority: number;
};

export const CATEGORY_CONFIG: Record<SearchCategory, CategoryConfig> = {
  articles: {
    label: "Articles",
    icon: BookOpen,
    color: "#B08030",
    priority: 1,
  },
  medications: {
    label: "Medications",
    icon: Syringe,
    color: "#38BDF8",
    priority: 2,
  },
  providers: {
    label: "Care Team",
    icon: Stethoscope,
    color: "#A8563A",
    priority: 3,
  },
  conditions: {
    label: "Conditions",
    icon: ClipboardList,
    color: "#B84A16",
    priority: 4,
  },
  tests: { label: "Tests", icon: TestTubes, color: "#6B5A4E", priority: 5 },
  procedures: {
    label: "Procedures",
    icon: Activity,
    color: "#6B5A4E",
    priority: 5.5,
  },
  documents: {
    label: "Documents",
    icon: FileText,
    color: "#8A7D74",
    priority: 6,
  },
  clinics: { label: "Clinics", icon: MapPin, color: "#A8563A", priority: 7 },
  supplements: {
    label: "Supplements",
    icon: Pill,
    color: "#4E7342",
    priority: 8,
  },
  programs: {
    label: "Programs",
    icon: GraduationCap,
    color: "#5E6E3E",
    priority: 9,
  },
  therapies: {
    label: "Therapies",
    icon: HeartPulse,
    color: "#5E6E3E",
    priority: 10,
  },
  grants: { label: "Grants", icon: Gift, color: "#B84A16", priority: 11 },
};
